import { EventName } from "~utils/event-tracking/event-tracking-constants"
import { useLogSelfOnboardingEvent } from "~utils/hooks/use-log-self-onboarding-event"

export function useLogOutfitterSelfOnboardingEvent() {
    return useLogSelfOnboardingEvent({
        stepStartedEventType: EventName.SELF_ONBOARDING_STEP_STARTED,
        stepCompletedEventType: EventName.SELF_ONBOARDING_STEP_COMPLETED,
        onboardingCompletedEventType: EventName.SELF_ONBOARDING_COMPLETED,
    })
}
